import './S_PaginationResults.scss';
import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
interface IProps {
  totalCount: number;
  pageSize: number;
  pageNumber: number;
}

export const S_PaginationResults = ({ totalCount, pageSize, pageNumber }: IProps): ReactElement => {
  const { t } = useTranslator();
  const startNumber = (pageNumber - 1) * pageSize + 1;
  const endNumber = Math.min(pageNumber * pageSize, totalCount);

  return <div className='pagination-result'>{t('pagination.results', { totalCount, startNumber, endNumber })}</div>;
};
